const ADDITIONAL_REPORT_OPTIONS = [{ label: 'Include allocation percentages', name: 'allocationPerc' }];

export { ADDITIONAL_REPORT_OPTIONS };
